import React from "react";
import { Routes, Route } from "react-router-dom";
import Home from "./pages/Home";

// لو هتضيفي صفحات تانية، اعملي import هنا:
// import About from "./pages/About";
// import Contact from "./pages/Contact";

function App() {
  return (
    <Routes>
      {/* الصفحة الرئيسية */}
      <Route path="/" element={<Home />} />

      {/* الصفحات المستقبلية: */}
      {/* <Route path="/about" element={<About />} /> */}
      {/* <Route path="/contact" element={<Contact />} /> */}

      {/* أي مسار غير موجود يحول للصفحة الرئيسية */}
      {/* <Route path="*" element={<Navigate to="/" />} /> */}
    </Routes>
  );
}

export default App;
